import React, { useState, useEffect } from 'react';
import { Typography, Form, Select, Popconfirm } from 'antd';
import TablaMontosCmp from './TablaMontosCmp';

const EdicionMontosCmp = ({ from, amounts, subtotal, typesPayment, amountLabel, refreshData, openDialogFilesWithParams }) => {

    const [amountForm] = Form.useForm();
    const [openDialogFiles, setDialogFiles] = useState(false);
    const [relationshipViewer, setRelationshipViewer] = useState({});    

    return (
        <>
            <Typography.Text strong style={{ marginTop: '16px', display: 'block' }}>{amountLabel}</Typography.Text>
            <Form 
                form={amountForm} 
                component={false}
            >
                <TablaMontosCmp
                    from={from}
                    amounts={amounts}
                    typesPayment={typesPayment}
                    subtotalLabel="Subtotal: "
                    subtotal={subtotal}
                    refreshData={refreshData}
                    openDialogFilesWithParams={openDialogFilesWithParams}
                    amountForm={amountForm}
                />
              
            </Form>
        </>
    )
}

export default EdicionMontosCmp;